// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__204I4","search":"Settings_search__2p290","filter":"Settings_filter__1WQni"};